/* eslint one-var: [0]*/
/* eslint max-len: [0]*/
/* eslint max-params: [0]*/
/* eslint complexity: [0]*/
/* eslint no-multi-assign: [0]*/

/**
 * Main JavaScript file.
 */

/*
 * Libs
 * require( './autoload/vendor.js' );
 */
import Barba from 'barba.js';
import Cookies from 'js-cookie';
import Instafeed from 'instafeed.js';
import Modernizr from 'modernizr';

// App Utils
import Utils from './utils/utils.js';
import Api from './utils/api.js';
import Router from './utils/router.js';
import Fixes from './utils/fixes.js';

// App Components
import Navigation from './components/navigation.js';
import Search from './components/search.js';
import Background from './components/background.js';
import NativeWPLightbox from './components/native-wp-lightbox.js';

/**
 * Vars
 */

/**
 * Init Classes
 */
const navigation = new Navigation(),
	search = new Search(),
	api = new Api(),
	siteBackground = new Background();	

/**
 * Functions
 */
siteBackground.init();

const initNiceScroll = () => {

};

const initTypoScroll = ( container ) => {
	const overviewContainer = container.querySelector( '.c-events-overview--v2' );	
	
	if ( ! overviewContainer ) {
		return; 
	}

	if ( Fixes.safari.is() && Modernizr.mq( '(max-width: 600px)' ) ) {
		// return;
	}

	const typoScrollContainer = overviewContainer.querySelectorAll( '.c-events-overview__item' );
	if ( typoScrollContainer.length ) {
		typoScrollContainer.forEach( ( el ) => { 
			const typoRows = el.querySelectorAll( '.c-events-overview__bg-typo' );
			const typoTimeline = gsap.timeline( {
				scrollTrigger: {
					trigger: el,
					start: 'top bottom',
					end: 'bottom top',
					scrub: 1, // smooth scrubbing, takes 1 second to "catch up" to the scrollbar
				},
				ease: 'circ.easeOut'
			} );

			typoRows.forEach( ( _el, _i ) => {
				typoTimeline.to( _el, {
					xPercent: `${_i % 2 === 0 ? '+' : '-'}=${Math.floor( Math.random() * ( 10 - 1 + 1 ) + 10 ) * -1}`,
				}, 0 );
			} );
		} );
	}
};

let initializedModals = [];
const initModals = ( container ) => {
	const $container = jQuery( container );

	if ( initializedModals.length > 0 ){
		jQuery.each( initializedModals, ( i, el ) => {
			const $modal = jQuery( `#${el}` );
			$modal.iziModal( 'destroy' );
			$modal.remove();
		} );
		initializedModals = [];
	}

	if ( $container.find( '.c-modal' ).length ){
		const $modals = $container.find( '.c-modal' );
		$modals.each( ( i, el ) => {
			const $modal = jQuery( el ),
				id = $modal.attr( 'id' );

			initializedModals.push( id );

			$container.on( 'click.oax::open-izi-modal', `a[href="#${id}"]`, ( event ) => {
				$modal.iziModal( 'open' );	
				event.preventDefault();
			} );

			$modal.iziModal();
		} );
	}
};

const removePreloader = () => {
	jQuery( 'html' ).removeClass( 'site--is-loading' );
};

const initFirstPageVisit = ( container ) => {
	removePreloader();
};

const instagramAccessToken = '7719444657.74d7b5d.b53bd4ba246644e1ad3b6532d93e7040'; // '143729578.39cf0eb.448e95ce796449218d70be7e86dc10bb';
const initInstaFeed = ( container ) => {
	const instaUserFeedId = 'c-instagram-feed';
	if ( jQuery( container ).find( `#${instaUserFeedId}` ).length ){
		const instaUserFeed = new Instafeed( {
			target: instaUserFeedId,
			get: 'user',
			userId: '7719444657',
			accessToken: instagramAccessToken,
			resolution: 'low_resolution',
			limit: 7,
			template: '<div class="c-instagram-feed__item w-1/2 md:w-1/3 float-left overflow-hidden relative"><a class="c-instagram-feed__item-link block leading-none ratio-square w-full" href="{{link}}" target="_blank"><img class="c-instagram-feed__item-img w-full h-full js--lazy absolute left-0 top-0 object-fit-cover" data-src="{{image}}" /></a></div>'
		} );
		instaUserFeed.run();
	}
};

const showAlerts = ( alerts ) => {
	if ( alerts.length > 0 ){
		const alertCookieArr = [], 
			alertCookie = typeof Cookies.get( 'event_alert' ) !== 'undefined' ? JSON.parse( Cookies.get( 'event_alert' ) ) : false,
			$alertWrapper = jQuery( '<div class="c-alert w-full fixed left-0 top-0 z-overlay"></div>' ),
			$alertIcon = jQuery( '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" class="w-1 h-1 mr-1 fill-current" viewBox="0 0 32 32"><defs><clipPath id="iconic-size-md-warning-clip-0"><path d="M0 0v30h31v-30h-31zm15.5 26c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5 1.5.672 1.5 1.5-.672 1.5-1.5 1.5zm1.5-10l-1 5h-1l-1-5v-6h3v6z" /></clipPath></defs><g transform="translate(0 1)"><path d="M.23 29.556l15.041-29.112c.127-.245.332-.245.459 0l15.041 29.112c.127.245.006.444-.27.444h-30c-.276 0-.397-.199-.27-.444z" clip-path="url(#iconic-size-md-warning-clip-0)" /></g></svg>' ),
			$alertContainerTemplate = jQuery( '<div class="c-alert__item px-1 py-1 bg-warning"><button class="c-alert__item-close border-none bg-transparent w-2 text-white h-full absolute pin-r top-0">X</button><div class="c-alert__item-inner pr-1"></div></div>' );

		alerts.forEach( ( alert ) => {
			if ( alertCookie === false || jQuery.inArray( alert.event_id, alertCookie ) !== -1 ){
				const $alertContainer = $alertContainerTemplate.clone(),
					$alertInner = $alertContainer.find( '.c-alert__item-inner' );
				
				$alertContainer.attr( 'data-event-id', alert.event_id );
				
				// $alertInner.append( $alertIcon );
				$alertInner.append( alert.alert_msg.split( '%name%' ).join( `<strong>„${alert.event_name}“</strong>` ) );
						
				$alertWrapper.append( $alertContainer );

				alertCookieArr.push( alert.event_id );
			}
		} );

		Cookies.set( 'event_alert', JSON.stringify( alertCookieArr ) );
		
		gsap.set( $alertWrapper.find( '.c-alert__item' ), {
			autoAlpha: 0,
			y: '-100%'
		} );

		jQuery( 'body' ).append( $alertWrapper );

		gsap.staggerTo( $alertWrapper.find( '.c-alert__item' ), 0.4, {
			autoAlpha: 1,
			y: '0%',
			onCompleteParams: ['{self}'],
			onComplete( tween ){
				const $el = jQuery( tween.target );
				$el.addClass( 'is-visible' );

				$el.one( 'click.oax::event-alert-close', 'button', ( event ) => {
					const $target = jQuery( event.target ).is( 'button' ) ? jQuery( event.target ) : jQuery( event.target ).closest( 'button' ),
						$alert = $target.closest( '.c-alert__item' ),
						alertArr = JSON.parse( Cookies.get( 'event_alert' ) ),
						alertIndex = alertArr.indexOf( $alert.data( 'eventId' ).toString() );

					gsap.to( $alert, 0.4, {
						autoAlpha: 0,
						y: '-100%',
						onCompleteParams: ['{self}'],
						onComplete( tweenAlert ){
							const $alertEl = jQuery( tweenAlert.target );
							
							alertArr.splice( alertIndex, 1 );
							$alertEl.remove();
							
							Cookies.set( 'event_alert', JSON.stringify( alertArr ) );
						}
					} );
				} );
			}
		} );
	}
};

/**
 * Router
 */
const onNewContainerLoaded = ( container ) => {
	Utils.progressBar( 'stop' );
	
	/**
	 * Fixes
	 */
	Fixes.reInit( container );

	/**
	 * Navigation
	 */
	navigation.setActiveState();

	/**
	 * Responsive Iframes
	 */
	Utils.responsiveIframes( container );
	
	/**
	 * Inject SVG's
	 */
	Utils.injectSVG( container );

	/**
	 * Modals
	 */
	initModals( container );
	
	/**
	 * Init Lightbox
	 */
	NativeWPLightbox.reInit( container );

	initTypoScroll( container );

	/**
	 * Init Instafeed
	 */
	initInstaFeed( container );
};

const onLinkClicked = ( ctx, HTMLElement, MouseEvent ) => {
	const $el = jQuery( HTMLElement ),
		href = $el.attr( 'href' );
	
	Utils.progressBar( 'start' );
	
	/*
	 * if ( $el.hasClass( 'js--page-transition--base' ) ){
	 * Barba.Pjax.getTransition = function(){
	 * return ctx.transitions.baseTransition();
	 * };
	 * } else if ( $el.hasClass( 'js--page-transition--preloader' ) ){
	 * Barba.Pjax.getTransition = function(){
	 * return ctx.transitions.preloaderTransition();
	 * };
	 * } else if ( $el.hasClass( 'js--page-transition--no' ) ){
	 * Barba.Pjax.getTransition = function(){
	 * return ctx.transitions.noTransition();
	 * };
	 * }	else {
	 * Barba.Pjax.getTransition = function(){
	 * return ctx.transitions.preloaderTransition();
	 * };
	 * }
	 */

	Barba.Pjax.getTransition = function(){
		return ctx.transitions.preloaderTransition();
	};	
};

const onInitStateChange = ( currentState ) => {
	// console.log( 'oninitstagechange', currentState );
};

const router = new Router( {
	onNewContainerLoaded,
	onLinkClicked,
	onInitStateChange
} );

/**
 * Events
 */

// Lazy Load
document.addEventListener( 'lazyloaded', ( e ) => {
	if ( e.target.classList.contains( 'js--canvas-filter' ) ){
		Utils.initImgCanvasFilter( e, e.target );
	}
	/*
	 * if( e.target.classList.contains('js--scale-on-load')){
	 *
	 * }
	 */
} );

document.addEventListener( ' lazybeforeunveil ', ( e ) => {
	console.log( 'lazybeforeunveil' );
} );

jQuery( document ).on( 'click.oax::event-table-click', '.c-events-table__excerpt', ( event ) => {
	const $target = jQuery( event.target );
	if ( $target.closest( '.c-events-table__row' ).length ){
		const $link = $target.closest( '.c-events-table__row' )
				.find( '.c-events-table__col--description' )
				.find( 'a:eq(0)' ),
			href = $link.attr( 'href' );
		
		onLinkClicked( router, $link, event );
		Utils.goToUrl( href );
	}
} );

// Event Filter
jQuery( document ).on( 'click.oax::event-filter-toggle', '.js--event-filter-toggle', ( event ) => {
	const $eventFilterOverlay = jQuery( '.c-event-filter' );
	$eventFilterOverlay.addClass( 'is-open' );
	Utils.scrollDisable( true );

	// maybe add esc key
	jQuery( document ).off( 'click.oax::event-filter-close' ).one( 'click.oax::event-filter-close', '.c-event-filter-close', ( e ) => {
		$eventFilterOverlay.removeClass( 'is-open' );
		Utils.scrollDisable( false );
		e.preventDefault();
	} );

	$eventFilterOverlay.off( 'click.oax::event-filter-link' ).one( 'click.oax::event-filter-link', 'a', ( e ) => {
		$eventFilterOverlay.removeClass( 'is-open' );
		Utils.scrollDisable( false );		
	} );

	event.preventDefault();
} );

// Search
search.init();

/**
 * Document Ready
 */
document.addEventListener( 'DOMContentLoaded', () => {
	const container = jQuery( '#site__body' ).find( '> .site__inner' ).get( 0 ); // document.getElementById( 'site__body' );

	/**
	 * Apply Fixes
	 */
	Fixes.init();

	/**
	 * Init Router
	 */
	router.init();

	/**
	 * Background
	 */
	if ( ! Utils.isMobile() && ! Fixes.safari.is() ){
		siteBackground.initParallax();
	} else if ( Utils.isMobile() ){
		// siteBackground.initParallax();
	}

	/**
	 * Init Navigation
	 */
	navigation.setupNavigation();

	/**
	 * Responsive Iframes
	 */
	Utils.responsiveIframes( container );

	/**
	 * Inject SVG's
	 */
	Utils.injectSVG( container );

	/**
	 * Init Glue Button
	 */
	Utils.initGlueButton( container );

	/**
	 * Init Lightbox
	 */
	NativeWPLightbox.init( container );
	
	/**
	 * 
	 */
	initModals( container );

	/**
	 * Init Instafeed
	 */
	initInstaFeed( container );

	/*
	 * Init NiceScroll
	 *
	 */
	initNiceScroll();

	initTypoScroll( container );

	/**
	 * Init First Page Visit
	 */
	initFirstPageVisit( container );
} );

api.getEventAlerts( 'future' ).then( ( result ) => {
	showAlerts( result );
} );

api.getTemplatePart( 'event-filter' ).then( ( result ) => {
	jQuery( 'body' ).append( result.html );
} );
